"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.MillenniumWeekday = void 0;
var underscore_1 = __importDefault(require("underscore"));
var MillenniumWeekday = /** @class */ (function () {
    function MillenniumWeekday(absoluteWeekdayNumber, representation) {
        this.absoluteWeekdayNumber = absoluteWeekdayNumber;
        this.representation = representation;
    }
    MillenniumWeekday.prototype.getRepresentation = function () {
        return this.representation;
    };
    MillenniumWeekday.prototype.getAbsoluteWeekdayNumber = function () {
        return this.absoluteWeekdayNumber;
    };
    MillenniumWeekday.prototype.getDay = function () {
        return this.absoluteWeekdayNumber;
    };
    // Only counts forward, i.e. Saturday is 5 days from Monday
    MillenniumWeekday.prototype.daysFromWeekday = function (weekday) {
        if (!(weekday instanceof MillenniumWeekday)) {
            throw new Error("daysFromWeekday must be invoked with a MillenniumWeekday");
        }
        var thisDay = this.getAbsoluteWeekdayNumber();
        var otherDay = weekday.getAbsoluteWeekdayNumber();
        if (otherDay > thisDay) {
            return 6 - thisDay;
        }
        return thisDay - otherDay;
    };
    MillenniumWeekday.prototype.daysFromMonday = function () {
        return this.daysFromWeekday(MillenniumWeekday.MONDAY);
    };
    MillenniumWeekday.prototype.equals = function (obj) {
        if (this === obj) {
            return true;
        }
        if (obj === null || obj === undefined) {
            return false;
        }
        if (!(obj instanceof MillenniumWeekday)) {
            return false;
        }
        return this.getAbsoluteWeekdayNumber() === obj.getAbsoluteWeekdayNumber();
    };
    // @returns The weekdays starting with the firstDayOfWeek
    // Currently only supports Sunday and Monday, Sunday being the default
    /* Better!
            const firstDayOfWeek = Language.firstDayOfWeek.absoluteWeekdayNumber;
            return _.range(0, 7).map(index => {
                return MillenniumWeekday.WEEKDAYS[(index + firstDayOfWeek) % 7];
            }, this);
    */
    MillenniumWeekday.getLocalizedWeekdayList = function (firstDayOfWeek) {
        var values = underscore_1["default"].clone(MillenniumWeekday.WEEKDAYS);
        if (firstDayOfWeek === MillenniumWeekday.MONDAY) {
            var sunday = values.shift();
            values.push(sunday);
        }
        return values;
    };
    MillenniumWeekday.getByRepresentation = function (representation) {
        var property;
        for (property in MillenniumWeekday) {
            if (MillenniumWeekday.hasOwnProperty(property)) {
                if (MillenniumWeekday[property] instanceof MillenniumWeekday) {
                    if (MillenniumWeekday[property].getRepresentation() === representation) {
                        return MillenniumWeekday[property];
                    }
                }
            }
        }
        throw new Error("No weekday \"".concat(representation, "\"."));
    };
    MillenniumWeekday.getByWeekdayNumber = function (weekdayNumber) {
        var property;
        for (property in MillenniumWeekday) {
            if (MillenniumWeekday.hasOwnProperty(property)) {
                if (MillenniumWeekday[property] instanceof MillenniumWeekday) {
                    if (MillenniumWeekday[property].getAbsoluteWeekdayNumber() === weekdayNumber) {
                        return MillenniumWeekday[property];
                    }
                }
            }
        }
        throw new Error("No weekday \"".concat(weekdayNumber, "\"."));
    };
    MillenniumWeekday.SUNDAY = new MillenniumWeekday(0, "sun");
    MillenniumWeekday.MONDAY = new MillenniumWeekday(1, "mon");
    MillenniumWeekday.TUESDAY = new MillenniumWeekday(2, "tue");
    MillenniumWeekday.WEDNESDAY = new MillenniumWeekday(3, "wed");
    MillenniumWeekday.THURSDAY = new MillenniumWeekday(4, "thu");
    MillenniumWeekday.FRIDAY = new MillenniumWeekday(5, "fri");
    MillenniumWeekday.SATURDAY = new MillenniumWeekday(6, "sat");
    MillenniumWeekday.WEEKDAYS = [
        MillenniumWeekday.SUNDAY,
        MillenniumWeekday.MONDAY,
        MillenniumWeekday.TUESDAY,
        MillenniumWeekday.WEDNESDAY,
        MillenniumWeekday.THURSDAY,
        MillenniumWeekday.FRIDAY,
        MillenniumWeekday.SATURDAY,
    ];
    return MillenniumWeekday;
}());
exports.MillenniumWeekday = MillenniumWeekday;
